export class NiveauRemboursement {
  soinsMedicaux: string = ''; //minimum, moyen, fort, maximum
  hospi: string = '';
  dentaire: string = '';
  optique: string = '';
  auditive: string = '';

  constructor(
    soinsMedicaux: string,
    hospi: string,
    dentaire: string,
    optique: string,
    auditive: string,
  ) {
    this.soinsMedicaux = soinsMedicaux;
    this.hospi = hospi;
    this.dentaire = dentaire;
    this.optique = optique;
    this.auditive = auditive;
  }
}
